module.exports = __webpack_public_path__ + "img/point2_bgcircle02.dc4e5d37.png";